<mat-sidenav-container class="nav-container noPrint">
    <mat-sidenav-content>
        <main class="main">
            <div class="noPrint" style="flex-flow: row wrap; display: flex; margin-right: 8px">
                <div style="flex: 1;"></div>
                <div style="flex: 7;">
                    <div style="display: flex; align-items: center; justify-content: space-between; margin: 0 5px;" class="full-width">
                        <picture>
                            <source media="(prefers-color-scheme: dark)" srcset="/assets/ianua-logo-light.svg">
                            <img src="/assets/ianua-logo-dark.svg" style="margin-top: 10px;" height="65px" alt="Ianua">
                        </picture>
                        <app-language-switcher></app-language-switcher>
                    </div>
                </div>
                <div style="flex: 1;"></div>
            </div>
            <div class="noPrint" style="flex-flow: row wrap; display: flex">
                <div style="flex: 1;"></div>
                <div style="flex: 7;">
                    <div class="header-separator mat-elevation-z3"></div>
                </div>
                <div style="flex: 1;"></div>
            </div>
            <div style="flex-flow: row wrap; display: flex">
                <div style="flex: 1;"></div>
                <div style="flex: 7;">
                    <router-outlet></router-outlet>
                </div>
                <div style="flex: 1;"></div>
            </div>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>







